import { AppHeader as ACEHeader } from '@ace-clublabs/shared-component-library';

export const Header: React.FC = () => {
  return <ACEHeader id="ace-logo" />;
};
